import { HttpErrorResponse } from '@angular/common/http';
import {Note} from './note';
import { NoteBuilder } from '../../builder/note.builder';

export class NoteHttpError extends Note {
  constructor(error: HttpErrorResponse) {
    super(error.status + '', 'circle-exclamation', error.statusText);

    return new NoteBuilder(error.status + '', 'circle-exclamation', error.statusText).setAlertNote().build();
  }
}
